fetch(
  `${window.Shopify.routes.root}browsing_context_suggestions.json` +
    '?country[enabled]=true' +
    '&language[enabled]=true',
)
  .then(r => r.json())
  .then(suggestions => {
    if (!suggestions?.suggestions?.length) return

    const highestConfidenceSuggestion = suggestions.suggestions.reduce(
      (prev, current) => {
        return current.confidence > prev.confidence ? current : prev
      },
    )

    const customerCountryCode =
      highestConfidenceSuggestion.parts?.country?.handle
    if (!customerCountryCode) return

    const blackListCountryCodes = 'AE,KW,SA,OM,QA'

    if (blackListCountryCodes.includes(customerCountryCode)) {
      window.location.href = `https://ohpolly.ae${window.location.pathname}`
    }
  })
  .catch(error => {
    console.error('Error fetching browsing context suggestions:', error)
  })
